(function ($) {
    // User clicks a news categories (select or deselect)
    $('.js-news-category').click(function (e) {
        // ?: Are there any selected news categories?
        if ($('.js-news-category:checked').length > 0) {
            // -> Yes, unselect the option for all news categories
            $('.js-all-news-categories').prop('checked', false);
        }
        else {
            // -> No, user is deselecting the last previous selected category.
            // Auto select all news categories.
            $('.js-all-news-categories').prop('checked', true);
        }
    });

    // User clicks the option for all categories
    $('.js-all-news-categories').click(function (e) {
        if (!this.checked) {
            // Get data-allow-none from the checkbox, if it is set to true, then allow user to uncheck all news categories.
            // Otherwise, don't allow the user to uncheck all news categories.
            let allowNone = $(this).data('allow-none');
            if (allowNone)
                return;
            
            // Don't allow user to uncheck all news categories. The option for all news categories is
            // unchecked when selecting a category.
            e.preventDefault();
        }
        else {
            // User is selecting all news. Unselect all previous selected categories.
            $('.js-news-category').prop('checked', false);
        }
    });
})(jQuery);